
import { useEffect, useRef, useState } from "react";

export const Features = () => {
  const [isVisible, setIsVisible] = useState(false);
  const featuresRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    
    if (featuresRef.current) {
      observer.observe(featuresRef.current);
    }
    
    return () => {
      observer.disconnect();
    };
  }, []);

  const features = [
    {
      title: "Transmettre",
      description: "Nous voulons faire redécouvrir aux jeunes générations les valeurs et les réalisations de la République, leur donner les outils pour en être à leur tour les gardiens et les artisans."
    },
    {
      title: "Renforcer",
      description: "Nous plaidons pour une extension de la Charte des droits et des devoirs du citoyen français à l'ensemble des citoyens, afin que chacun, né ou devenu Français, prenne conscience de ce que signifie appartenir à cette nation singulière."
    },
    {
      title: "Protéger", 
      description: "Nous sommes déterminés à mener des actions en justice ou dans les médias contre ceux qui, par calcul ou par négligence, s'attaquent aux fondements de la République, qu'ils soient élus ou citoyens, institutions ou groupes d'influence."
    }
  ];

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="w-full md:w-3/5 space-y-4">
            <div className="relative inline-block mb-2">
              <h2 className="text-2xl font-bold font-acumin text-[#00123A] relative z-10 md:text-2xl">Notre mission</h2>
              <div className="absolute bottom-0 left-0 w-full h-[40%] bg-[#39CCFF] -z-10"></div>
            </div>
            
            <div className="space-y-4">
              <div className="w-full overflow-hidden rounded-xl">
                <img 
                  src="/lovable-uploads/e1470fc8-cfcb-4dec-bf6c-9550ab5ca88c.png" 
                  alt="Liberté, égalité, fraternité & laïcité" 
                  className="w-full h-auto object-contain"
                />
              </div>
              
              {/* Removed the duplicated list that was here */}
            </div>
          </div>
          
          <div className="w-full md:w-2/5 mt-6 md:mt-0 flex flex-col items-center">
            <div ref={featuresRef} className="space-y-6">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className={`relative bg-[#F7F7F7] rounded-xl shadow-sm overflow-hidden group transition-all duration-500 ${
                    isVisible 
                      ? 'opacity-100 translate-y-0' 
                      : 'opacity-0 translate-y-8'
                  }`}
                  style={{ 
                    transitionDelay: `${index * 200}ms` 
                  }}
                >
                  <div className="p-6">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#39CCFF] text-white font-bold font-acumin">
                        {index + 1}
                      </div>
                      <h3 className="text-2xl font-bold text-[#39CCFF] font-acumin">{feature.title}</h3>
                    </div>
                    <p className="text-gray-600 mt-3 font-acumin text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
